var React = require('react');

function CheckmarkInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.9321 2L6.26546 10.6663L1.93213 6.33333","stroke":"#FC5C03","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

CheckmarkInline.defaultProps = {"width":"17","height":"13","viewBox":"0 0 17 13","fill":"none"};

module.exports = CheckmarkInline;

CheckmarkInline.default = CheckmarkInline;
